import { useQuery } from "@tanstack/react-query";
import { useRequest } from "./useRequests";
import { Order } from "@Oway-Inc/web-components";

export const useOrder = (orderId?: string) => {
  const { get, isReady } = useRequest();

  return useQuery({
    queryKey: ["order", orderId],
    queryFn: async () => {
      const response = await get<Order>(`v1/transfer/orders/${orderId}`);
      return response;
    },
    enabled: !!orderId && isReady,
  });
};
